<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ 'bikeshop.rentals.security_deposit_buttons.capture' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss({})">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">


    <div>
        <div class="row margin-top-8">
            <div class="col-md-6 label" [ngClass]="{ 'red' : !valid()}">{{
                'bikeshop.rentals.booking.capture_payment_amount' | translate }}:
            </div>
            <div class="col-md-6">
                <input type="number" pInputText [(ngModel)]="securityDepositInfo.capturedAmount"/>
            </div>
        </div>

        <div class="row margin-top-16" *ngIf="securityDepositInfo.capturedAmount > 0 && !valid()">
            <div class="col-md-12 red">
                {{ 'bikeshop.rentals.booking.capture_amount_error' | translate : {authorizationAmount: partner.CurrencySymbol + securityDepositInfo.authorizationAmount.toFixed(2)} }}
            </div>
        </div>

    </div>
</div>
<div class="modal-footer">
    <div class="row margin-top-8">
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised full-width"
                    label="{{'general.cancel' | translate}}" (click)="modal.dismiss({})"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised full-width"
                    label="{{'bikeshop.rentals.security_deposit_buttons.capture' | translate}}"
                    (click)="capturePaymentAmount()"
                    [disabled]="!valid()"></button>
        </div>
    </div>
</div>
